module.exports = __webpack_public_path__ + "assets/TrapezoidGeomMeanDetailed.e7af3cbbd2107b56c1eee7a512270c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrapezoidGeomMeanDetailed.png
// module id = 593
// module chunks = 0